import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import { IScheduleTaxBreakupResponse } from '../types/reviewAndPublish.type';
import { endPointUrls } from '../constants/endPoints';

const getTaxScheduleBreakup = (scheduleId: string): Promise<IScheduleTaxBreakupResponse> => {
    return axiosInstance
        .get(endPointUrls.getScheduleTaxBreakup + scheduleId)
        .then((res: AxiosResponse<IScheduleTaxBreakupResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const reviewAndPublishServices = {
    getTaxScheduleBreakup,
};

export default reviewAndPublishServices;
